import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import Employee201FileTable from "../../DataTables/Workforce/201File/201FileTable";
import { CRUDPermissions } from "../../../Types/Common/Access";

interface UserAccessProps {
  access: CRUDPermissions;
}

const Employee201FileContainer: React.FC<UserAccessProps> = ({ access }) => {
  return (
    <>
      <Breadcrumbs mainTitle="201 File" parent="Workforce" />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <Employee201FileTable access={access} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Employee201FileContainer;
